/* eslint-disable @typescript-eslint/no-explicit-any */
import { WritableAtom } from 'jotai'
import React, { PropsWithChildren } from 'react'
import { ScopeProvider } from 'jotai-scope'
import { useHydrateAtoms } from 'jotai/utils'

// Copied from useHydrateAtoms type signature
export type AnyWritableAtom = WritableAtom<unknown, any[], any>
export type AtomTuple<A = AnyWritableAtom, V = unknown> = readonly [A, V]

const AtomsHydrator = ({
  atomValues,
  children,
}: PropsWithChildren<{
  atomValues: [AnyWritableAtom, unknown][]
}>) => {
  useHydrateAtoms(atomValues)
  return children
}

export const ScopeProviderWithInitializer = ({
  atomValues,
  children,
}: PropsWithChildren<{
  atomValues: [AnyWritableAtom, unknown][]
}>) => {
  const atoms = Array.from(atomValues, ([anAtom]) => anAtom)
  return (
    <ScopeProvider atoms={atoms}>
      <AtomsHydrator atomValues={atomValues}>{children}</AtomsHydrator>
    </ScopeProvider>
  )
}
